export const shipperAdminOptions = (adminSettings, offPlatformSettings, intl, quotingSettings, developerSettings) => [
  ...(adminSettings.view_company_settings
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.companyDetails",
            defaultMessage: "Company details",
          }),
          key: "company-details",
          permission: adminSettings.view_company_settings,
        },
      ]
    : []),
  ...(adminSettings.view_users
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.teamMembers",
            defaultMessage: "Team members",
          }),
          key: "team-members",
          permission: adminSettings.view_users,
        },
      ]
    : []),
  ...(adminSettings.view_user_roles
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.userRoles",
            defaultMessage: "User roles",
          }),
          key: "user-roles",
          permission: adminSettings.view_user_roles,
        },
      ]
    : []),
  ...(adminSettings.view_email_notifications
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.emailNotifications",
            defaultMessage: "Email notifications",
          }),
          key: "email-notifications",
          permission: adminSettings.view_email_notifications,
        },
      ]
    : []),
  ...(adminSettings.view_locations
    ? [
        {
          label: intl.formatMessage({
            id: "general.paymentLocations",
            defaultMessage: "Payment locations",
          }),
          key: "payment-location-settings",
          permission: adminSettings.view_locations,
        },
      ]
    : []),
  ...(adminSettings.view_providers
    ? [
        {
          label: intl.formatMessage({
            id: "general.providers",
            defaultMessage: "Providers",
          }),
          key: "providers",
          permission: adminSettings.view_providers,
        },
      ]
    : []),
  ...(adminSettings.view_approval_levels
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.approvalLevels",
            defaultMessage: "Approval levels",
          }),
          key: "approval-levels",
          permission: adminSettings.view_approval_levels,
        },
      ]
    : []),
  ...(adminSettings.view_attachment_buckets
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.invoiceAttachmentBuckets",
            defaultMessage: "Invoice attachment buckets",
          }),
          key: "invoice-attachment-buckets",
          permission: adminSettings.view_attachment_buckets,
        },
      ]
    : []),
  ...(quotingSettings.can_edit_prefills
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.prefills",
            defaultMessage: "Prefills",
          }),
          key: "prefills",
          permission: true,
        },
      ]
    : []),
  ...(adminSettings.view_rate_card
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.rateCards",
            defaultMessage: "Rate Cards",
          }),
          key: "rate-cards",
          permission: adminSettings.view_rate_card,
        },
      ]
    : []),
  ...(adminSettings.perform_file_import || offPlatformSettings.create_tracker
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.fileImportTools",
            defaultMessage: "File Import Tools",
          }),
          key: "file-import-tools",
          permission: adminSettings.perform_file_import || offPlatformSettings.create_tracker,
        },
      ]
    : []),
  ...(adminSettings.create_edit_parcel_account
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.parcelAccounts",
            defaultMessage: "Parcel Accounts",
          }),
          key: "parcel-accounts",
          permission: adminSettings.create_edit_parcel_account,
        },
      ]
    : []),
  ...(developerSettings?.create_developer_tokens
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.apiTokens",
            defaultMessage: "API Tokens",
          }),
          key: "api-tokens",
          permission: true,
        },
      ]
    : []),
];

export const shipperSettingsOptions = (testIds) => [
  {
    keyName: "your-details",
    testId: testIds.YOUR_DETAILS_BUTTON,
    message: "settings.side-menu.yourDetails",
    defaultText: "Your details",
  },
  {
    keyName: "notifications",
    testId: testIds.NOTIFICATIONS_BUTTON,
    message: "general.notifications",
    defaultText: "Notifications",
  },
  {
    keyName: "address-book",
    testId: testIds.ADDRESS_BOOK_BUTTON,
    message: "settings.side-menu.addressBook",
    defaultText: "Address book",
  },
  {
    keyName: "contact-list",
    testId: testIds.CONTACT_LIST_BUTTON,
    message: "settings.side-menu.contactList",
    defaultText: "Contact list",
  },
  {
    keyName: "presets-templates",
    testId: testIds.PRESETS_AND_TEMPLATES_BUTTON,
    message: "settings.side-menu.presetsAndTemplates",
    defaultText: "Presets and Templates",
  },
];
